export const MBD_TYPE = {
  TRAVEL_TOOLS_APP_CARD: 'TRAVEL_TOOLS_APP_CARD',
  TRAVEL_TOOLS_PAGE: 'TRAVEL_TOOLS_PAGE',
} as const;

export type MbdType = (typeof MBD_TYPE)[keyof typeof MBD_TYPE];

export const MBD_ITEMS = {
  [MBD_TYPE.TRAVEL_TOOLS_APP_CARD]: {
    id: 'travel_tools_app_card',
    name: 'travel_tools_app_card',
  },
  [MBD_TYPE.TRAVEL_TOOLS_PAGE]: {
    id: 'travel_tools_page',
    name: 'travel_tools_page',
  },
} as const;
